import React from 'react';
import {XIcon} from 'lucide-react';
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '../../../../components/ui/shadcn-components/alert-dialog';
import {translate} from '../../utils/localization-utils';

interface TextModalPanelInterface {
	title?: string;
	open: boolean;
	onClose?: (result: boolean) => void;
	textValue: string;
	confirmLabel: string;
	cancelLabel: string;
	hasLink?: string;
}

export default function TextModalPanel({
	title,
	open,
	onClose,
	textValue,
	confirmLabel,
	cancelLabel,
	hasLink
}: TextModalPanelInterface) {

	const handleCloseClick = () => {
		if (hasLink) {
			window.location.href = hasLink;
		} else {
			onClose(false);
		}
	};

	return (
		<div>
			<AlertDialog open={open}>
				<AlertDialogContent className="flex flex-col justify-between items-end text-blue">
					<AlertDialogHeader className="w-full">
							<div className="flex items-center justify-between w-full px-5 pt-5 rounded-t-sm">
								<AlertDialogTitle className={'font-medium text-2xl'}>{title}</AlertDialogTitle>
								<div className="cursor-pointer text-gray-500 transition-colors duration-200 hover:text-black" onClick={handleCloseClick}>
									<XIcon className={'text-blue'}/>
								</div>
							</div>
						<AlertDialogDescription className={`font-normal p-5 text-xl ${title ? 'text-base' : 'text-xl' }`}>
							{textValue}
						</AlertDialogDescription>
					</AlertDialogHeader>
					<AlertDialogFooter className={'px-5 pb-5'}>
						<AlertDialogCancel onClick={handleCloseClick}>{translate('buttonClose')}</AlertDialogCancel>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</div>
	);
}
